import { enqueue } from './core'
import { incrementPageCount } from './session'
import { Events, Category, Config } from './constants'

let currentPath = ''
let enterTime = 0
let visibleTime = 0
let lastVisibleStart = 0
let heartbeatTimer = null

function resetDwell(path) {
  if (currentPath && enterTime) {
    emitPageLeave()
  }
  currentPath = path
  enterTime = Date.now()
  visibleTime = 0
  lastVisibleStart = document.visibilityState === 'visible' ? Date.now() : 0
  startHeartbeat()
}

function emitPageLeave() {
  try {
    if (!currentPath || !enterTime) return
    if (!document.hidden && lastVisibleStart) {
      visibleTime += Date.now() - lastVisibleStart
    }
    enqueue({
      eventName: Events.PAGE_LEAVE,
      eventCategory: Category.AUTO,
      pagePath: currentPath,
      eventParams: {
        page_path: currentPath,
        dwell_ms: Date.now() - enterTime,
        visible_ms: visibleTime,
      },
    })
  } catch { /* 静默 */ }
}

function onVisibilityChange() {
  try {
    if (document.visibilityState === 'hidden') {
      if (lastVisibleStart) {
        visibleTime += Date.now() - lastVisibleStart
        lastVisibleStart = 0
      }
      stopHeartbeat()
    } else {
      lastVisibleStart = Date.now()
      startHeartbeat()
    }
  } catch { /* 静默 */ }
}

function startHeartbeat() {
  stopHeartbeat()
  heartbeatTimer = setInterval(() => {
    try {
      if (document.visibilityState !== 'visible') return
      const engaged = visibleTime + (lastVisibleStart ? Date.now() - lastVisibleStart : 0)
      enqueue({
        eventName: Events.HEARTBEAT,
        eventCategory: Category.AUTO,
        pagePath: currentPath,
        eventParams: { engaged_ms: engaged },
      })
    } catch { /* 静默 */ }
  }, Config.HEARTBEAT_INTERVAL)
}

function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer)
    heartbeatTimer = null
  }
}

export function setupDwellTracking(router) {
  document.addEventListener('visibilitychange', onVisibilityChange)

  router.afterEach((to, from) => {
    try {
      const path = to.path || to.fullPath
      const fromPath = from.path || from.fullPath

      // 跳转到后台管理路由时，停止追踪并清空状态
      if (path.startsWith('/admin')) {
        stopHeartbeat()
        currentPath = ''
        enterTime = 0
        visibleTime = 0
        lastVisibleStart = 0
        return
      }

      // page_leave for previous page
      if (currentPath) emitPageLeave()

      // page_view for new page
      incrementPageCount()
      enqueue({
        eventName: Events.PAGE_VIEW,
        eventCategory: Category.AUTO,
        pagePath: path,
        eventParams: {
          page_path: path,
          page_name: to.name || '',
          from_path: fromPath,
          title: document.title,
        },
      })

      // reset dwell for new page
      resetDwell(path)
    } catch { /* 静默 */ }
  })

  window.addEventListener('beforeunload', () => {
    try {
      emitPageLeave()
      stopHeartbeat()
    } catch { /* 静默 */ }
  })
}
